/**
 * Mini GLOW — hero carousel + scroll reveals
 */
(function () {
  var root = document.querySelector('[data-mini-glow-carousel]');
  if (root && root.dataset.mgInit !== '1') {
    root.dataset.mgInit = '1';

    var hero = root.closest('.mg-hero');
    var slides = root.querySelectorAll('.mg-hero__slide');
    var dotWrap = hero ? hero.querySelector('.mg-hero__dots') : null;
    var dots = [];

    if (slides.length && dotWrap) {
      dotWrap.innerHTML = '';
      for (var di = 0; di < slides.length; di++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mg-hero__dot' + (di === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Foto ' + (di + 1));
        btn.setAttribute('aria-selected', di === 0 ? 'true' : 'false');
        dotWrap.appendChild(btn);
      }
      dots = dotWrap.querySelectorAll('.mg-hero__dot');
    }

    var i = 0;
    var timer;
    var interval = 5200;

    function show(n) {
      i = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function (el, j) {
        el.classList.toggle('is-active', j === i);
        el.setAttribute('aria-hidden', j === i ? 'false' : 'true');
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
        d.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
    }

    function next() {
      show(i + 1);
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(next, interval);
    }

    function stop() {
      clearInterval(timer);
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion && slides.length > 1) {
      show(0);
      start();
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      dots.forEach(function (dot, j) {
        dot.addEventListener('click', function () {
          stop();
          show(j);
          start();
        });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
    } else {
      show(0);
    }
  }

  /* Reveal on scroll */
  var revealables = document.querySelectorAll('.mini-glow-landing .mg-reveal');
  if (revealables.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              var delay = en.target.dataset.mgRevealDelay;
              if (delay) en.target.style.transitionDelay = delay;
              en.target.classList.add('mg-reveal--in');
              obs.unobserve(en.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      revealables.forEach(function (el) {
        obs.observe(el);
      });
    } else {
      revealables.forEach(function (el) {
        el.classList.add('mg-reveal--in');
      });
    }
  } else {
    revealables.forEach(function (el) {
      el.classList.add('mg-reveal--in');
    });
  }
})();
